/* tslint:disable */
/* eslint-disable */
export enum TailCoverageType {
  EmployeePaid = 'EmployeePaid',
  SharedCost = 'SharedCost',
  EmployerPaid = 'EmployerPaid',
  VariesBasedOnTermination = 'VariesBasedOnTermination',
  VestingSchedule = 'VestingSchedule'
}
